import React from "react"
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import SpotifyListen from "../../atoms/spotify-listen/spotifyListen";
import AudioCard from "../../atoms/audio-card/audioCard";
import "./audioPlayer.scss"
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

const AudiosPlayer = (props: ReferenciaContenido) => {

   return (
      <div className="m-audios">
            <div className="m-audios__upper">
                <h2 className="m-audios__upper__title">{props.tituloGeneral}</h2>
                {props.descripcion ?
                    <p className="m-audios__upper__subtitle">{documentToReactComponents(props.descripcion.json)}</p>
                :
                    null
                }
            <div className="m-audios__list">
                {props.referenciaPlantillaContenido.map((audio, key) => {
                    if (audio.audioPrincipal) {
                        return (
                            <div className="m-audios__list__audio">
                                <AudioCard download audio={audio} key={key}/>
                            </div>
                        )
                    }
                    else if (audio.redireccionBoton) {
                        return (
                            <div className="m-audios__list__audio">
                                <SpotifyListen audio={audio} key={key}/>
                            </div>
                        )
                    }
                })}
            </div>
          </div>
      </div>
   )
}

export default AudiosPlayer